import { MouseEvent } from 'react';

import { Loader } from 'components';
import AttachFileIcon from '@material-ui/icons/AttachFile';

import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  loading: boolean;
  name: string;
  withIcon?: boolean;
  download: () => Promise<void>;
}

const EventDocumentView: React.FC<Props> = ({
  loading,
  name,
  download,
  withIcon = false,
}) => {
  const classes = useStyles();

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    download();
  };

  return (
    <div className={classes.root}>
      {loading && (
        <Loader
          size={15}
          themeColor="darkBlue"
          cls={{ root: classes.loader }}
        />
      )}
      <div
        onClick={handleClick}
        className={clsx(classes.root, classes.pointer)}
      >
        {withIcon ? <AttachFileIcon className={classes.attachIcon} /> : null}
        <span className={classes.name}>{name}</span>
      </div>
    </div>
  );
};

export default EventDocumentView;
